import * as React from 'react'
import Layout from '../components/layout'

const PrivacyPage = () => {
  return (
    <Layout
      pageTitle="Privacy Policy"
      titleOverride="Privacy Policy | Columbia Children's Center"
      metaDesc="Review the Privacy Policy for Columbia Children's Center website and services."
      pathname="/privacy/"
    >
      <a href="https://app.tryplayground.com/X7tvoDUHwazFjm1hgbal/book/j2qKHKe4akbD4Cv9DED7" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginBottom: '1rem', padding: '0.75rem 1.5rem', backgroundColor: '#007bff', color: '#fff', textDecoration: 'none', borderRadius: '0.375rem', fontWeight: 'bold' }}>Book a Tour</a>
      <div style={{ lineHeight: '1.8', color: '#333' }}>
        {/* <h2>Privacy Policy</h2> */}
        
        <p><strong>Effective Date:</strong> April 17, 2026</p>
        <p><strong>Last Updated:</strong> April 17, 2026</p>

        <hr />

        <h3>Introduction</h3>
        <p>Columbia Children's Center ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and safeguard information when you access or use our website located at <a href="https://columbiachildrenscenter.com">https://columbiachildrenscenter.com</a> (the "Site").</p>

        <p>Please review this Policy carefully. By accessing or using the Site, you acknowledge and accept the practices described in this Privacy Policy. If you do not agree with the terms outlined here, please discontinue use of the Site.</p>

        <hr />

        <h3>1. Information We Collect</h3>
        <p>We, along with our service providers and technology partners, may collect various categories of information, including:</p>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number (when provided)</li>
          <li>IP address</li>
          <li>General geographic location</li>
          <li>Information submitted through forms (which may include a child's name, date of birth, health or medical details, or other sensitive information)</li>
          <li>Public social media profile details if you interact with us through social platforms</li>
          <li>Technical and usage information such as browser type, referring pages, device model, Internet service provider, and usage behavior</li>
          <li>User-generated submissions such as messages, feedback, images, or form responses</li>
        </ul>

        <p>We may also compile anonymous or aggregated information that does not directly identify any individual.</p>

        <hr />

        <h3>2. Methods of Data Collection</h3>
        <p>Information may be collected through several channels, including:</p>
        <ul>
          <li>Completing forms on our Site</li>
          <li>Signing up for newsletters or marketing communications</li>
          <li>Communicating with us through email, SMS, or social media platforms</li>
          <li>Interacting with embedded content or social media integrations</li>
          <li>Automated technologies such as cookies, tracking pixels, and analytics services (including Google Analytics 4 and Meta Pixel)</li>
        </ul>

        <p>These technologies may record data such as IP address, time spent on pages, browser details, and referral sources.</p>

        <hr />

        <h3>3. How We Use Collected Information</h3>
        <p>The information we collect may be used for purposes including:</p>
        <ul>
          <li>Responding to inquiries or form submissions</li>
          <li>Sending marketing emails or SMS messages when you have opted in</li>
          <li>Monitoring Site usage and improving performance and user experience</li>
          <li>Conducting marketing analysis and targeted advertising</li>
          <li>Protecting against fraudulent activity and maintaining security</li>
          <li>Complying with legal obligations</li>
        </ul>

        <p><strong>We do not sell personal information to third parties.</strong></p>

        <hr />

        <h3>4. Cookies and Similar Tracking Technologies</h3>
        <p>Our Site uses cookies, tracking pixels, and similar tools to:</p>
        <ul>
          <li>Analyze visitor activity and audience demographics</li>
          <li>Deliver advertisements that may be more relevant to you (through platforms such as Google Ads or Meta Ads)</li>
          <li>Improve Site functionality and performance</li>
        </ul>

        <p>Most browsers allow you to control cookie preferences through their settings. For additional information about advertising opt-out tools, you may visit:</p>
        <ul>
          <li><a href="http://www.aboutads.info/" target="_blank" rel="noreferrer">Digital Advertising Alliance</a></li>
          <li><a href="http://www.networkadvertising.org/" target="_blank" rel="noreferrer">Network Advertising Initiative</a></li>
        </ul>

        <hr />

        <h3>5. Sharing and Disclosure of Information</h3>
        <p>Your information may be shared with certain third parties where necessary, including:</p>
        <ul>
          <li>Website hosting and infrastructure providers</li>
          <li>Customer relationship management (CRM) or marketing automation platforms</li>
          <li>Analytics and advertising partners</li>
          <li>Legal authorities or government agencies when required by law</li>
        </ul>

        <p>We may also share anonymized or aggregated data for analytical, research, or marketing improvement purposes.</p>

        <hr />

        <h3>6. Your Privacy Rights</h3>
        <p>Individuals residing in certain U.S. states, including California, Virginia, Colorado, Connecticut, and Utah, may have additional rights under applicable privacy laws. These rights may include:</p>

        <ul>
          <li><strong>Right to Know</strong> – Request information about the personal data we collect, how it is used, and with whom it is shared.</li>
          <li><strong>Right to Delete</strong> – Request deletion of personal data, subject to certain legal exceptions.</li>
          <li><strong>Right to Correct</strong> – Request correction of inaccurate personal information.</li>
          <li><strong>Right to Opt Out of Targeted Advertising or Profiling</strong> – Request that your data not be used for behavioral advertising.</li>
          <li><strong>Right to Limit Use of Sensitive Information</strong> – Request restrictions on how sensitive data is used beyond essential services.</li>
          <li><strong>Right to Non-Discrimination</strong> – Exercise privacy rights without being denied services or receiving discriminatory treatment.</li>
        </ul>

        <p>To exercise these rights or request to opt out of certain uses of your data, contact us using the information provided below. We may verify your identity using the information you previously provided. If submitting a request on behalf of another person, documentation confirming your authorization may be required.</p>

        <hr />

        <h3>7. Data Retention</h3>
        <p>We retain personal information only for as long as reasonably necessary to fulfill the purposes described in this Policy, unless a longer retention period is required or permitted by law.</p>

        <p>You may unsubscribe from marketing emails by selecting the unsubscribe link in any message. For marketing text messages, you may reply STOP to opt out.</p>

        <hr />

        <h3>8. Children's Privacy</h3>
        <p>Certain forms on the Site may request information about a child, such as name or date of birth, provided by a parent or legal guardian. We do not knowingly collect personal information directly from children under the age of 13 without verifiable parental consent, consistent with the Children's Online Privacy Protection Act (COPPA).</p>

        <p>If you believe we have collected information about a child in violation of this Policy, please contact us. After verification, we will promptly remove the data from our records.</p>

        <hr />

        <h3>9. Data Security</h3>
        <p>We maintain administrative, technical, and physical safeguards designed to protect personal data from unauthorized access, misuse, or disclosure. These safeguards may include encrypted data transmission and storage, secure server infrastructure, access restrictions, role-based permissions, and routine security reviews.</p>

        <p>Despite these protections, no internet transmission or electronic storage system can be guaranteed to be completely secure. Users should also take steps to protect their personal information.</p>

        <hr />

        <h3>10. Automated Processing</h3>
        <p>Limited automated processing tools may be used to enhance the Site and user experience. These may include:</p>
        <ul>
          <li>Displaying advertising based on previous browsing behavior</li>
          <li>Using analytics to improve how services are presented</li>
          <li>Automatically filtering messages or submissions to identify spam or misuse</li>
        </ul>

        <p>These processes do not make legally binding decisions or prevent access to the Site. Where applicable by law, you may request human review of decisions made solely through automated processing.</p>

        <hr />

        <h3>11. Do Not Track Signals</h3>
        <p>Some web browsers offer a "Do Not Track" (DNT) setting intended to signal a user's tracking preferences across websites. At this time, our Site does not respond to DNT signals due to the absence of a universally accepted standard. We may revisit this approach as industry practices and regulatory guidance evolve.</p>

        <hr />

        <h3>12. Accessibility</h3>
        <p>We aim to make our Privacy Policy accessible to all users, including individuals with disabilities. If you need this policy provided in an alternative format such as large print, audio, or simplified language, or if you encounter accessibility barriers while using our Site, please contact us. We will make reasonable efforts to accommodate accessibility requests.</p>

        <hr />

        <h3>13. Manage Cookie Preferences</h3>
        <p>You may control your cookie preferences through your browser settings or by using our cookie consent tool (when available). These tools may allow you to accept or reject certain non-essential cookies and modify preferences at any time through a banner or footer link.</p>

        <p>Essential cookies necessary for core Site functionality may remain active even if other cookies are disabled.</p>

        <hr />

        <h3>14. SMS Communications</h3>
        <p>If you provide your phone number and consent through a form checkbox, you agree to receive SMS messages from Columbia Children's Center regarding inquiries, services, and marketing communications.</p>

        <p>Message frequency may vary. Standard message and data rates may apply.</p>

        <p>You may opt out at any time by replying STOP, or request assistance by replying HELP.</p>

        <p>Phone numbers collected for SMS communications will not be shared, sold, or rented to third parties or affiliates for marketing purposes.</p>

        <hr />

        <h3>15. Updates to This Privacy Policy</h3>
        <p>We may revise this Privacy Policy periodically. Any updates will be posted on this page and will include an updated Last Updated date indicating when the most recent changes were made.</p>

        <hr />

        <h3>16. Contact Information</h3>
        <p>If you have questions about this Privacy Policy or wish to exercise any of your privacy rights, please contact us:</p>

        <p>
          <strong>Columbia Children's Center</strong><br />
          Email: <a href="mailto:info@columbiachildrenscenter.com">info@columbiachildrenscenter.com</a><br />
          Website: <a href="https://columbiachildrenscenter.com">https://columbiachildrenscenter.com</a>
        </p>

        <hr />

        <h3>Helpful Resources</h3>
        <ul>
          <li><a href="http://www.aboutads.info/" target="_blank" rel="noreferrer">Digital Advertising Alliance</a></li>
          <li><a href="http://www.networkadvertising.org/" target="_blank" rel="noreferrer">Network Advertising Initiative</a></li>
        </ul>

        <hr />

        <p style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#666' }}>
          <em>Last Updated: April 17, 2026</em>
        </p>
      </div>
    </Layout>
  )
}

export default PrivacyPage
